import React from 'react';
import { InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

// 휴대폰(xs)에서 검색어 입력창 끝에 붙는 돋보기 버튼.
// type="submit"이라 폼의 onSubmit(=검색)을 그대로 호출한다. sm 이상에서는 숨김(기존 검색 버튼 사용).
const MobileSearchAdornment = ({ disabled }) => (
  <InputAdornment position="end" sx={{ display: { xs: 'flex', sm: 'none' } }}>
    <IconButton type="submit" size="small" aria-label="검색" disabled={disabled} edge="end">
      <SearchIcon fontSize="small" />
    </IconButton>
  </InputAdornment>
);

export default MobileSearchAdornment;
